export default {
        "sounds/ui": {
            audioFiles: [import.meta.ROLLUP_FILE_URL_BGH7MJYM, import.meta.ROLLUP_FILE_URL_DL6qhcAi],
            spriteFile: import.meta.ROLLUP_FILE_URL_Cr1qCRgM
        },
"speech/da/female/30": {
            audioFiles: [import.meta.ROLLUP_FILE_URL_Cu_XaJx8, import.meta.ROLLUP_FILE_URL_ngrUe6rn],
            spriteFile: import.meta.ROLLUP_FILE_URL_O0bJnnix
        },
"speech/da/female/75": {
            audioFiles: [import.meta.ROLLUP_FILE_URL_BFItOX1$, import.meta.ROLLUP_FILE_URL_C6SF2Wdj],
            spriteFile: import.meta.ROLLUP_FILE_URL_CK9uX6gN
        },
"speech/da/female/80": {
            audioFiles: [import.meta.ROLLUP_FILE_URL_D2ldft2i, import.meta.ROLLUP_FILE_URL_CktZiAxy],
            spriteFile: import.meta.ROLLUP_FILE_URL_NATelcjB
        },
"speech/da/female/90": {
            audioFiles: [import.meta.ROLLUP_FILE_URL_Bquwo2rl, import.meta.ROLLUP_FILE_URL_BYAs9xo8],
            spriteFile: import.meta.ROLLUP_FILE_URL_CTlFaJjp
        },
"speech/da/female/announcer": {
            audioFiles: [import.meta.ROLLUP_FILE_URL_B2kJ3G71, import.meta.ROLLUP_FILE_URL_pQp8FxUM],
            spriteFile: import.meta.ROLLUP_FILE_URL_DjSQLQFc
        },
"speech/es/female_colombia/30": {
            audioFiles: [import.meta.ROLLUP_FILE_URL_B3D1jqm1, import.meta.ROLLUP_FILE_URL_B76E6mqF],
            spriteFile: import.meta.ROLLUP_FILE_URL_BSPSKOqi
        },
"speech/es/female_colombia/75": {
            audioFiles: [import.meta.ROLLUP_FILE_URL_BtOMsMue, import.meta.ROLLUP_FILE_URL_L8ak6i1z],
            spriteFile: import.meta.ROLLUP_FILE_URL_CAofviqg
        },
"speech/es/female_colombia/90": {
            audioFiles: [import.meta.ROLLUP_FILE_URL_DKMvaao5, import.meta.ROLLUP_FILE_URL_DXkrPmbA],
            spriteFile: import.meta.ROLLUP_FILE_URL_0lolBwYV
        },
"speech/da/nobingo/30": {
            audioFiles: [import.meta.ROLLUP_FILE_URL_D2WftcPj, import.meta.ROLLUP_FILE_URL_2mV84Fdy],
            spriteFile: import.meta.ROLLUP_FILE_URL_DNZukV3e
        },
"speech/da/nobingo/75": {
            audioFiles: [import.meta.ROLLUP_FILE_URL_BEpDX8La, import.meta.ROLLUP_FILE_URL_Ci_RdcGi],
            spriteFile: import.meta.ROLLUP_FILE_URL_C6HMhskH
        },
"speech/da/nobingo/80": {
            audioFiles: [import.meta.ROLLUP_FILE_URL_C9UDGGYn, import.meta.ROLLUP_FILE_URL_B5SPIRip],
            spriteFile: import.meta.ROLLUP_FILE_URL_Cd$Vpsd3
        },
"speech/da/nobingo/90": {
            audioFiles: [import.meta.ROLLUP_FILE_URL_BU6r1mtA, import.meta.ROLLUP_FILE_URL_DaY3LWRU],
            spriteFile: import.meta.ROLLUP_FILE_URL_UHQgkkOB
        },
"speech/da/nobingo/announcer": {
            audioFiles: [import.meta.ROLLUP_FILE_URL_D8wqURRR, import.meta.ROLLUP_FILE_URL_dOMo43nE],
            spriteFile: import.meta.ROLLUP_FILE_URL_DHqj66dR
        },
"speech/es/ganatodo/30": {
            audioFiles: [import.meta.ROLLUP_FILE_URL_skps9pRg, import.meta.ROLLUP_FILE_URL_B4u40RpA],
            spriteFile: import.meta.ROLLUP_FILE_URL_TT1K_ufY
        },
"speech/es/ganatodo/75": {
            audioFiles: [import.meta.ROLLUP_FILE_URL_6GxSPA1K, import.meta.ROLLUP_FILE_URL_C5hKdA2M],
            spriteFile: import.meta.ROLLUP_FILE_URL_DtJj_EVr
        },
"speech/es/ganatodo/80": {
            audioFiles: [import.meta.ROLLUP_FILE_URL_DKhUqfYZ, import.meta.ROLLUP_FILE_URL_DlN0GzqJ],
            spriteFile: import.meta.ROLLUP_FILE_URL_CA3NfBoD
        },
"speech/es/ganatodo/90": {
            audioFiles: [import.meta.ROLLUP_FILE_URL_Ca7HkVB5, import.meta.ROLLUP_FILE_URL_BrKhw56m],
            spriteFile: import.meta.ROLLUP_FILE_URL_D4AzsIvN
        },
"speech/es/ganatodo/announcer": {
            audioFiles: [import.meta.ROLLUP_FILE_URL_BNjuV1Gf, import.meta.ROLLUP_FILE_URL_D3xyjU0m],
            spriteFile: import.meta.ROLLUP_FILE_URL_CStRiV9N
        },
"speech/es/female_colombia2/announcer": {
            audioFiles: [import.meta.ROLLUP_FILE_URL_Dj2yExay, import.meta.ROLLUP_FILE_URL_BlkVKdHK],
            spriteFile: import.meta.ROLLUP_FILE_URL_sUQZnzke
        },
"speech/en/alistair/30": {
            audioFiles: [import.meta.ROLLUP_FILE_URL_i3XKIo7S, import.meta.ROLLUP_FILE_URL_BaA5_vhL],
            spriteFile: import.meta.ROLLUP_FILE_URL_jFvLem40
        },
"speech/en/alistair/75": {
            audioFiles: [import.meta.ROLLUP_FILE_URL_BOvqJfPd, import.meta.ROLLUP_FILE_URL_Cc7KTnI0],
            spriteFile: import.meta.ROLLUP_FILE_URL_DiDTsT$V
        },
"speech/en/alistair/80": {
            audioFiles: [import.meta.ROLLUP_FILE_URL_BjOvhMxV, import.meta.ROLLUP_FILE_URL_BTcWBH9k],
            spriteFile: import.meta.ROLLUP_FILE_URL_6LU15fuL
        },
"speech/en/alistair/90": {
            audioFiles: [import.meta.ROLLUP_FILE_URL_BV4QTDOw, import.meta.ROLLUP_FILE_URL_BvS_kEBq],
            spriteFile: import.meta.ROLLUP_FILE_URL_DRZftkvc
        },
"speech/en/alistair/announcer": {
            audioFiles: [import.meta.ROLLUP_FILE_URL_Bfut89eW, import.meta.ROLLUP_FILE_URL_W5rb1Adu],
            spriteFile: import.meta.ROLLUP_FILE_URL_CAdkrnP2
        },
"speech/en/belinda_female/30": {
            audioFiles: [import.meta.ROLLUP_FILE_URL_B66Hhbpb, import.meta.ROLLUP_FILE_URL_Com0q4NS],
            spriteFile: import.meta.ROLLUP_FILE_URL_Amvjl9sS
        },
"speech/en/belinda_female/75": {
            audioFiles: [import.meta.ROLLUP_FILE_URL_DQ1EXh92, import.meta.ROLLUP_FILE_URL_G2dyX2zh],
            spriteFile: import.meta.ROLLUP_FILE_URL_CnM21sz2
        },
"speech/en/belinda_female/80": {
            audioFiles: [import.meta.ROLLUP_FILE_URL_BFGYwg4O, import.meta.ROLLUP_FILE_URL_5OrVmZ3T],
            spriteFile: import.meta.ROLLUP_FILE_URL_CHQds0HI
        },
"speech/en/belinda_female/90": {
            audioFiles: [import.meta.ROLLUP_FILE_URL_CeDn112w, import.meta.ROLLUP_FILE_URL_CC8Pf8hO],
            spriteFile: import.meta.ROLLUP_FILE_URL_C0C3laq3
        },
"speech/en/belinda_female/announcer": {
            audioFiles: [import.meta.ROLLUP_FILE_URL_vaKgBlth, import.meta.ROLLUP_FILE_URL_DRXfojup],
            spriteFile: import.meta.ROLLUP_FILE_URL_B_LE4VzA
        },
"speech/en/firstnation/30": {
            audioFiles: [import.meta.ROLLUP_FILE_URL_e4B9Afpr, import.meta.ROLLUP_FILE_URL_uN2PIbdQ],
            spriteFile: import.meta.ROLLUP_FILE_URL_6hxD7vZ$
        },
"speech/en/firstnation/75": {
            audioFiles: [import.meta.ROLLUP_FILE_URL_eB2Z9f4T, import.meta.ROLLUP_FILE_URL_Dl2NSNff],
            spriteFile: import.meta.ROLLUP_FILE_URL_BqqXkSGO
        },
"speech/en/firstnation/announcer": {
            audioFiles: [import.meta.ROLLUP_FILE_URL_C7Xr5kml, import.meta.ROLLUP_FILE_URL_CKnhdXPt],
            spriteFile: import.meta.ROLLUP_FILE_URL_ph33S91P
        },
"speech/en/female/30": {
            audioFiles: [import.meta.ROLLUP_FILE_URL_MPgfZHct, import.meta.ROLLUP_FILE_URL_D885nTIb],
            spriteFile: import.meta.ROLLUP_FILE_URL_PpfNoUpl
        },
"speech/en/female/75": {
            audioFiles: [import.meta.ROLLUP_FILE_URL_DZ0duqCB, import.meta.ROLLUP_FILE_URL_BDIIkdxK],
            spriteFile: import.meta.ROLLUP_FILE_URL_DC0a3IM6
        },
"speech/en/female/80": {
            audioFiles: [import.meta.ROLLUP_FILE_URL_B6eCzIjW, import.meta.ROLLUP_FILE_URL_Du5OJ9L0],
            spriteFile: import.meta.ROLLUP_FILE_URL_rjy_8lBo
        },
"speech/en/female/90": {
            audioFiles: [import.meta.ROLLUP_FILE_URL_BdyKzHW6, import.meta.ROLLUP_FILE_URL_55npjuh0],
            spriteFile: import.meta.ROLLUP_FILE_URL_rl$8kuev
        },
"speech/en/female/announcer": {
            audioFiles: [import.meta.ROLLUP_FILE_URL_BziTGTAK, import.meta.ROLLUP_FILE_URL_BbtE8NuW],
            spriteFile: import.meta.ROLLUP_FILE_URL_BAzJdoXY
        },
"speech/en/jack_male/30": {
            audioFiles: [import.meta.ROLLUP_FILE_URL_DLhxp1kF, import.meta.ROLLUP_FILE_URL_C3WDrPN3],
            spriteFile: import.meta.ROLLUP_FILE_URL_BLz$OTrv
        },
"speech/en/jack_male/75": {
            audioFiles: [import.meta.ROLLUP_FILE_URL_DCLp0y3N, import.meta.ROLLUP_FILE_URL_DmQygIzQ],
            spriteFile: import.meta.ROLLUP_FILE_URL_C24WfHsA
        },
"speech/en/jack_male/80": {
            audioFiles: [import.meta.ROLLUP_FILE_URL_BdyilDvf, import.meta.ROLLUP_FILE_URL_DmE$fBBL],
            spriteFile: import.meta.ROLLUP_FILE_URL_BNp8qMyy
        },
"speech/en/jack_male/90": {
            audioFiles: [import.meta.ROLLUP_FILE_URL_vuIhVfBx, import.meta.ROLLUP_FILE_URL_YCkSrj9x],
            spriteFile: import.meta.ROLLUP_FILE_URL_F$Of262y
        },
"speech/en/jack_male/announcer": {
            audioFiles: [import.meta.ROLLUP_FILE_URL_BNmCQ5ib, import.meta.ROLLUP_FILE_URL_t_ZS$C2E],
            spriteFile: import.meta.ROLLUP_FILE_URL_jEDbVGqX
        },
"speech/en/male/30": {
            audioFiles: [import.meta.ROLLUP_FILE_URL_BREjsw6Y, import.meta.ROLLUP_FILE_URL_DBJKZuQA],
            spriteFile: import.meta.ROLLUP_FILE_URL_BCQiahDn
        },
"speech/en/male/75": {
            audioFiles: [import.meta.ROLLUP_FILE_URL_9kPrXUjs, import.meta.ROLLUP_FILE_URL_Cy6byWIS],
            spriteFile: import.meta.ROLLUP_FILE_URL_CESQHoho
        },
"speech/en/male/80": {
            audioFiles: [import.meta.ROLLUP_FILE_URL_Brjv0mSP, import.meta.ROLLUP_FILE_URL_rewqsyrf],
            spriteFile: import.meta.ROLLUP_FILE_URL_snzY633X
        },
"speech/en/male/90": {
            audioFiles: [import.meta.ROLLUP_FILE_URL_0AAHvHZh, import.meta.ROLLUP_FILE_URL_DX5OaVmV],
            spriteFile: import.meta.ROLLUP_FILE_URL_B28gRKmD
        },
"speech/en/male/announcer": {
            audioFiles: [import.meta.ROLLUP_FILE_URL_E4rFATWj, import.meta.ROLLUP_FILE_URL_Buxa3TUE],
            spriteFile: import.meta.ROLLUP_FILE_URL_BXHCE5gI
        },
"speech/en/patrick/30": {
            audioFiles: [import.meta.ROLLUP_FILE_URL_DVSwkQIg, import.meta.ROLLUP_FILE_URL_nd49zoyf],
            spriteFile: import.meta.ROLLUP_FILE_URL_D60SxMf4
        },
"speech/en/patrick/75": {
            audioFiles: [import.meta.ROLLUP_FILE_URL_z7jaaqEA, import.meta.ROLLUP_FILE_URL_5r_jJgoU],
            spriteFile: import.meta.ROLLUP_FILE_URL_D2mYp_46
        },
"speech/en/patrick/80": {
            audioFiles: [import.meta.ROLLUP_FILE_URL_BPl4158p, import.meta.ROLLUP_FILE_URL_CgY6KIGe],
            spriteFile: import.meta.ROLLUP_FILE_URL_1Z5pS6kB
        },
"speech/en/patrick/90": {
            audioFiles: [import.meta.ROLLUP_FILE_URL_DpeHeB51, import.meta.ROLLUP_FILE_URL_DVqoJnMB],
            spriteFile: import.meta.ROLLUP_FILE_URL_BZDJKnUE
        },
"speech/en/patrick/announcer": {
            audioFiles: [import.meta.ROLLUP_FILE_URL_imusDgxy, import.meta.ROLLUP_FILE_URL_CrWoy$nA],
            spriteFile: import.meta.ROLLUP_FILE_URL_D3pmun0J
        },
"speech/en/wbpete/30": {
            audioFiles: [import.meta.ROLLUP_FILE_URL_Bq_kQAn7, import.meta.ROLLUP_FILE_URL_C9t93ADR],
            spriteFile: import.meta.ROLLUP_FILE_URL_Dz8XYqVa
        },
"speech/en/wbpete/75": {
            audioFiles: [import.meta.ROLLUP_FILE_URL_DPAHDMND, import.meta.ROLLUP_FILE_URL_C$xTQycB],
            spriteFile: import.meta.ROLLUP_FILE_URL_BzuhJz8j
        },
"speech/en/wbpete/90": {
            audioFiles: [import.meta.ROLLUP_FILE_URL_y_tKcElo, import.meta.ROLLUP_FILE_URL_UIAk71aF],
            spriteFile: import.meta.ROLLUP_FILE_URL_BfMKzB9k
        },
"speech/en/wbpete/announcer": {
            audioFiles: [import.meta.ROLLUP_FILE_URL_Cah_rJbX, import.meta.ROLLUP_FILE_URL_eCYo6qLT],
            spriteFile: import.meta.ROLLUP_FILE_URL_BTyU$8Bc
        },
"speech/fr/female/30": {
            audioFiles: [import.meta.ROLLUP_FILE_URL_KUTaatsG, import.meta.ROLLUP_FILE_URL_B1yo_WxZ],
            spriteFile: import.meta.ROLLUP_FILE_URL_BBDQ$bUC
        },
"speech/fr/female/75": {
            audioFiles: [import.meta.ROLLUP_FILE_URL_BjBSf6MA, import.meta.ROLLUP_FILE_URL_C1u8ERZS],
            spriteFile: import.meta.ROLLUP_FILE_URL_Dp6WZPkp
        },
"speech/fr/female/80": {
            audioFiles: [import.meta.ROLLUP_FILE_URL_D3Xw5RTv, import.meta.ROLLUP_FILE_URL_DlEsqjtP],
            spriteFile: import.meta.ROLLUP_FILE_URL_BFQbyz2G
        },
"speech/fr/female/90": {
            audioFiles: [import.meta.ROLLUP_FILE_URL_C$iR0Utb, import.meta.ROLLUP_FILE_URL_4EYTxGYv],
            spriteFile: import.meta.ROLLUP_FILE_URL_BIQsmIWF
        },
"speech/fr/female/announcer": {
            audioFiles: [import.meta.ROLLUP_FILE_URL_C4Dl8piA, import.meta.ROLLUP_FILE_URL_CzwGWtjl],
            spriteFile: import.meta.ROLLUP_FILE_URL_C7GT2MEC
        },
"speech/mx/female/30": {
            audioFiles: [import.meta.ROLLUP_FILE_URL_Bq0XzDrr, import.meta.ROLLUP_FILE_URL_SW7o3fa5],
            spriteFile: import.meta.ROLLUP_FILE_URL_a2bquJXy
        },
"speech/mx/female/75": {
            audioFiles: [import.meta.ROLLUP_FILE_URL_CVt_zDAT, import.meta.ROLLUP_FILE_URL_DYCni2At],
            spriteFile: import.meta.ROLLUP_FILE_URL_DaC$NUxZ
        },
"speech/mx/female/80": {
            audioFiles: [import.meta.ROLLUP_FILE_URL_C4TOusjB, import.meta.ROLLUP_FILE_URL_B9MJ4nQR],
            spriteFile: import.meta.ROLLUP_FILE_URL_DLsb1HNj
        },
"speech/mx/female/90": {
            audioFiles: [import.meta.ROLLUP_FILE_URL_BS8GwHll, import.meta.ROLLUP_FILE_URL_B1yrVo8u],
            spriteFile: import.meta.ROLLUP_FILE_URL_CeVJ9bbP
        },
"speech/mx/female/announcer": {
            audioFiles: [import.meta.ROLLUP_FILE_URL_CC20hXgN, import.meta.ROLLUP_FILE_URL_BS61lyLe],
            spriteFile: import.meta.ROLLUP_FILE_URL_BmzDrVtZ
        },
"speech/pt/bbnfemale/30": {
            audioFiles: [import.meta.ROLLUP_FILE_URL_BkUvYQic, import.meta.ROLLUP_FILE_URL_DDMPPdTG],
            spriteFile: import.meta.ROLLUP_FILE_URL_BIMqL5Hb
        },
"speech/pt/bbnfemale/75": {
            audioFiles: [import.meta.ROLLUP_FILE_URL_BXyk50pN, import.meta.ROLLUP_FILE_URL_ezKZOwMl],
            spriteFile: import.meta.ROLLUP_FILE_URL_D3CRYmr9
        },
"speech/pt/bbnfemale/80": {
            audioFiles: [import.meta.ROLLUP_FILE_URL_Cq0pGz5x, import.meta.ROLLUP_FILE_URL_1z670Tb7],
            spriteFile: import.meta.ROLLUP_FILE_URL_CH_q$bqH
        },
"speech/pt/bbnfemale/90": {
            audioFiles: [import.meta.ROLLUP_FILE_URL_CgM2pjc6, import.meta.ROLLUP_FILE_URL_DcIociZN],
            spriteFile: import.meta.ROLLUP_FILE_URL_reYAAUyZ
        },
"speech/pt/bbnfemale/announcer": {
            audioFiles: [import.meta.ROLLUP_FILE_URL_0dz0X3Bc, import.meta.ROLLUP_FILE_URL_8ibZahLa],
            spriteFile: import.meta.ROLLUP_FILE_URL_cIYB1fBm
        },
"speech/pt/brivalmale/30": {
            audioFiles: [import.meta.ROLLUP_FILE_URL_BG60HHvF, import.meta.ROLLUP_FILE_URL_XpFHHH8y],
            spriteFile: import.meta.ROLLUP_FILE_URL_CG_6AkuB
        },
"speech/pt/brivalmale/75": {
            audioFiles: [import.meta.ROLLUP_FILE_URL_hNdKnFpG, import.meta.ROLLUP_FILE_URL_BJwWliaT],
            spriteFile: import.meta.ROLLUP_FILE_URL_DGLC_2g2
        },
"speech/pt/brivalmale/80": {
            audioFiles: [import.meta.ROLLUP_FILE_URL_4I8wjkIW, import.meta.ROLLUP_FILE_URL_CeBDTOpW],
            spriteFile: import.meta.ROLLUP_FILE_URL_CP303uiP
        },
"speech/pt/brivalmale/90": {
            audioFiles: [import.meta.ROLLUP_FILE_URL_CfD_2MTG, import.meta.ROLLUP_FILE_URL_omFGRv8M],
            spriteFile: import.meta.ROLLUP_FILE_URL_CUEvvfGL
        },
"speech/pt/brivalmale/announcer": {
            audioFiles: [import.meta.ROLLUP_FILE_URL_R8jBOXdi, import.meta.ROLLUP_FILE_URL_hQxXGK4z],
            spriteFile: import.meta.ROLLUP_FILE_URL_CHChaVdN
        },
"speech/pt/brivalmale2/30": {
            audioFiles: [import.meta.ROLLUP_FILE_URL_DO1c3pSy, import.meta.ROLLUP_FILE_URL_D0tSMwhH],
            spriteFile: import.meta.ROLLUP_FILE_URL_FZ31gDjE
        },
"speech/pt/brivalmale2/75": {
            audioFiles: [import.meta.ROLLUP_FILE_URL_czBqMZ4U, import.meta.ROLLUP_FILE_URL_Dmo7dQcQ],
            spriteFile: import.meta.ROLLUP_FILE_URL_xUy5wf71
        },
"speech/pt/brivalmale2/80": {
            audioFiles: [import.meta.ROLLUP_FILE_URL_D6iaAY$x, import.meta.ROLLUP_FILE_URL_CQXQ3rVl],
            spriteFile: import.meta.ROLLUP_FILE_URL_BPXx$3Ka
        },
"speech/pt/brivalmale2/90": {
            audioFiles: [import.meta.ROLLUP_FILE_URL_BgHJNNS8, import.meta.ROLLUP_FILE_URL_5WQnTFkJ],
            spriteFile: import.meta.ROLLUP_FILE_URL_w5fValTs
        },
"speech/pt/brivalmale2/announcer": {
            audioFiles: [import.meta.ROLLUP_FILE_URL_51rIvCBA, import.meta.ROLLUP_FILE_URL__$DkdY_2],
            spriteFile: import.meta.ROLLUP_FILE_URL_5UFA0M3R
        },
"speech/pt/female/30": {
            audioFiles: [import.meta.ROLLUP_FILE_URL_l9K_NL8z, import.meta.ROLLUP_FILE_URL_DnIl_4Bh],
            spriteFile: import.meta.ROLLUP_FILE_URL_C0rWuL7K
        },
"speech/pt/female/75": {
            audioFiles: [import.meta.ROLLUP_FILE_URL_DJt5DjqK, import.meta.ROLLUP_FILE_URL_eaKy06wT],
            spriteFile: import.meta.ROLLUP_FILE_URL_BslY_der
        },
"speech/pt/female/80": {
            audioFiles: [import.meta.ROLLUP_FILE_URL_Dhi2mqy5, import.meta.ROLLUP_FILE_URL_DIiBU9oJ],
            spriteFile: import.meta.ROLLUP_FILE_URL_DvGyPFSd
        },
"speech/pt/female/90": {
            audioFiles: [import.meta.ROLLUP_FILE_URL_CeogA6g1, import.meta.ROLLUP_FILE_URL_CSF7Acsj],
            spriteFile: import.meta.ROLLUP_FILE_URL_DejnIOYZ
        },
"speech/pt/female/announcer": {
            audioFiles: [import.meta.ROLLUP_FILE_URL_Bo1ki7cy, import.meta.ROLLUP_FILE_URL_DKHFsUox],
            spriteFile: import.meta.ROLLUP_FILE_URL_TTYEerZ_
        },
"speech/pt/male/30": {
            audioFiles: [import.meta.ROLLUP_FILE_URL_7c$HSrFV, import.meta.ROLLUP_FILE_URL_BjTUPQ_d],
            spriteFile: import.meta.ROLLUP_FILE_URL_CMpptqz9
        },
"speech/pt/male/75": {
            audioFiles: [import.meta.ROLLUP_FILE_URL_Db_srxy0, import.meta.ROLLUP_FILE_URL_DRFk25_2],
            spriteFile: import.meta.ROLLUP_FILE_URL_DUv1ap4T
        },
"speech/pt/male/80": {
            audioFiles: [import.meta.ROLLUP_FILE_URL_BDthVVQo, import.meta.ROLLUP_FILE_URL_C2MvIMHt],
            spriteFile: import.meta.ROLLUP_FILE_URL_C6xBLXPG
        },
"speech/pt/male/90": {
            audioFiles: [import.meta.ROLLUP_FILE_URL_BWxCOXK8, import.meta.ROLLUP_FILE_URL_CywtKujy],
            spriteFile: import.meta.ROLLUP_FILE_URL_CXJ2IUQ3
        },
"speech/pt/male/announcer": {
            audioFiles: [import.meta.ROLLUP_FILE_URL_BeV8A5GN, import.meta.ROLLUP_FILE_URL_C5ZaLodw],
            spriteFile: import.meta.ROLLUP_FILE_URL_DO17zhVj
        },
"speech/pt/maximusfemale/30": {
            audioFiles: [import.meta.ROLLUP_FILE_URL_JT4ekKUs, import.meta.ROLLUP_FILE_URL_B2GZK8bK],
            spriteFile: import.meta.ROLLUP_FILE_URL_A8_j4Gq1
        },
"speech/pt/maximusfemale/75": {
            audioFiles: [import.meta.ROLLUP_FILE_URL_DUQKlVmV, import.meta.ROLLUP_FILE_URL_BJtzI0gE],
            spriteFile: import.meta.ROLLUP_FILE_URL_CJQ6MREF
        },
"speech/pt/maximusfemale/90": {
            audioFiles: [import.meta.ROLLUP_FILE_URL_DaZuVSah, import.meta.ROLLUP_FILE_URL_B5aUQUwX],
            spriteFile: import.meta.ROLLUP_FILE_URL_DS3O6D4u
        },
"speech/pt/maximusfemale/announcer": {
            audioFiles: [import.meta.ROLLUP_FILE_URL_LNg6fdEQ, import.meta.ROLLUP_FILE_URL_DUkoNDJk],
            spriteFile: import.meta.ROLLUP_FILE_URL_CoTXb5MZ
        },
"speech/sv/female/30": {
            audioFiles: [import.meta.ROLLUP_FILE_URL_BvpwudEY, import.meta.ROLLUP_FILE_URL_BldEmma7],
            spriteFile: import.meta.ROLLUP_FILE_URL_B2ODyCFG
        },
"speech/sv/female/75": {
            audioFiles: [import.meta.ROLLUP_FILE_URL_CqIi7Yqn, import.meta.ROLLUP_FILE_URL_DYrRW7Cy],
            spriteFile: import.meta.ROLLUP_FILE_URL_BrdVg3yx
        },
"speech/sv/female/90": {
            audioFiles: [import.meta.ROLLUP_FILE_URL_CP5II9lI, import.meta.ROLLUP_FILE_URL_$Wt_TjHO],
            spriteFile: import.meta.ROLLUP_FILE_URL_GW72L7xs
        },
"speech/sv/female/announcer": {
            audioFiles: [import.meta.ROLLUP_FILE_URL_ClZom1YD, import.meta.ROLLUP_FILE_URL_CSJlNALK],
            spriteFile: import.meta.ROLLUP_FILE_URL_B_vcGT82
        }
    };